module.exports = __webpack_public_path__ + "static/media/contact07.d85411e6.png";